import styled from "styled-components";

import { fontFamily } from "../grid";


export const DatePickerWrapper = styled("div").withConfig({displayName: "DatePickerWrapper"})`
    /* react-datepicker injects these divs around customInput — keep them full-width */
    .react-datepicker-wrapper,
    .react-datepicker__input-container {
        width: 100%;
    }

    .react-datepicker {
        font: 14px ${fontFamily}, "Segoe UI", sans-serif !important;
        background: #FFFFFF;
        border: 1px solid #DFDFDF;
        box-shadow: 0px 0px 20px rgba(0, 58, 120, 0.15);
        border-radius: 10px;
        padding: 10px;
    }

    .react-datepicker .react-datepicker__month {
        margin: 0;
    }

    .react-datepicker__month-wrapper {
        display: flex;
        flex-direction: row;
        gap: 5px;
    }

    .react-datepicker__header {
        background-color: transparent;
        border-bottom: 0;
        padding: 0;
    }

    .react-datepicker__month-container .react-datepicker__month .react-datepicker__month-text {
        display: inline-flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0;

        width: 38px;
        height: 30px;

        border-radius: 4px;

        /* Inside auto layout */
        flex: none;
        order: 0;
        flex-grow: 1;

    }

    .react-datepicker__month-container .react-datepicker__month-text {
        color: var(--heeros-blue-600-brand);
    }

    .react-datepicker__month-container .react-datepicker__month-text:hover {
        background: rgba(240, 243, 247, 1);
    }

    .react-datepicker__month-container .react-datepicker__month-text--selected,
    .react-datepicker__month-container .react-datepicker__month-text--selected:hover,
    .react-datepicker__month-container .react-datepicker__month-text--selected:not([aria-disabled=true]):hover {
        color: var(--heeros-blue-600-brand);
        background: rgba(240, 243, 247, 1);
    }

    /* Range day highlighting — scoped to range-mode pickers only */
    &.dp-range-mode .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
        background-color: rgba(89, 82, 224, 0.12);
        color: var(--heeros-blue-600-brand);
        border-radius: 0;
    }

    &.dp-range-mode .react-datepicker__day--range-start,
    &.dp-range-mode .react-datepicker__day--range-end {
        background-color: #5952E0 !important;
        color: #ffffff !important;
        border-radius: 4px !important;
    }

    &.dp-range-mode .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
        background-color: transparent;
        color: #0B0B14;
        border-radius: 0;
    }

    /* Dual-input row (start + end wrapper + optional reset) */
    .dp-dual-row {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    /* Row containing the two date fields + separator + optional reset */
    .dp-range-input-wrapper {
        display: flex;
        align-items: center;
        gap: 6px;
    }

    /* Individual date field — each has its own border */
    .dp-date-field {
        display: flex;
        align-items: center;
        border: 1px solid #5952E0;
        border-radius: 8px;
        overflow: hidden;
        background: #ffffff;
        height: 32px;
        transition: box-shadow 0.2s ease;

        &:focus-within {
            box-shadow: 0 0 0 3px rgba(89, 82, 224, 0.38);
        }

        /* react-datepicker wraps customInput in extra divs — make them fill the field */
        .react-datepicker-wrapper {
            height: 100%;
        }
        .react-datepicker__input-container {
            height: 100%;
        }
    }

    /* Each half input (start / end) */
    .dp-half-input {
        border: none;
        outline: none;
        padding: 0 10px;
        font: 13px ${fontFamily}, "Segoe UI", sans-serif;
        letter-spacing: 0.46px;
        color: #5952E0;
        background: transparent;
        width: 148px;
        height: 100%;
        cursor: text;

        &::placeholder {
            color: #6f6a8f;
            opacity: 1;
        }

        &::-webkit-input-placeholder {
            color: #6f6a8f;
            opacity: 1;
        }

        &:hover {
            background: rgba(89, 82, 224, 0.04);
        }
    }

    .dp-half-input--error {
        color: #C20A38 !important;
        border-color: #C20A38 !important;
    }

    .dp-range-sep {
        flex-shrink: 0;
        padding: 0 2px;
        color: #5952E0;
        font-size: 13px;
        user-select: none;
    }

    .dp-nav-btn {
        background: none;
        border: none;
        cursor: pointer;
        padding: 5px 15px;
        color: #5952E0;
        align-items: center;
        font: 14px Borna, "Segoe UI", sans-serif !important;
        line-height: 1;
        transition: background 0.15s ease;

        &:hover {
            background: rgba(89, 82, 224, 0.08);
            border-radius: 4px;
        }
    }

    .dp-input-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    .dp-input-wrapper--error .dp-half-input {
        color: #C20A38;
        border-color: #C20A38;
    }

    .dp-calendar-icon {
        position: absolute;
        right: 8px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #6F42C1;
        pointer-events: all;
    }

    /* Single-field datepicker — full-width variant of dp-half-input */
    .dp-single-input {
        border: none;
        outline: none;
        padding: 0 36px 0 10px;
        font: 13px ${fontFamily}, "Segoe UI", sans-serif;
        letter-spacing: 0.46px;
        color: #0B0B14;
        background: transparent;
        width: 100%;
        height: 100%;
        cursor: text;

        &::placeholder {
            color: #6f6a8f;
            opacity: 1;
        }

        &:hover {
            background: rgba(89, 82, 224, 0.04);
        }
    }

    /* Modifiers for the single-field variant */
    .dp-date-field--single {
        width: 100%;
        min-width: 0;   /* prevent flex shrink below content */
        height: 37px;  /* project's base rem < 16px, so Form.Control renders ~36px; keeps fields flush */
        border-radius: 6px;

        /* Propagate full width through react-datepicker's injected wrapper divs */
        .react-datepicker-wrapper {
            width: 100%;
            height: 100%;
        }
        .react-datepicker__input-container {
            width: 100%;
            height: 100%;
        }
    }

    .dp-date-field--disabled {
        opacity: 0.5;
        pointer-events: none;
        background: #f5f5f5;
    }

    .dp-date-field--error,
    .dp-date-field:has(.dp-input-wrapper--error) {
        border-color: #C20A38;
        background-color: #C20A380A;

        .dp-single-input,
        .dp-half-input {
            color: #C20A38;
        }

        .dp-calendar-icon {
            color: #C20A38;
        }
    }

    /* Custom calendar navigation header */
    .dp-custom-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 2px 0 6px;
    }

    .dp-header-label {
        font: 14px Borna, "Segoe UI", sans-serif !important;
        color: #0B0B14;
        text-transform: capitalize;
        display: inline-flex;
        align-items: center;
    }

    /* Clickable month / year parts of the header */
    .dp-header-btn {
        background: none;
        border: none;
        cursor: pointer;
        font: 14px Borna, "Segoe UI", sans-serif !important;
        color: #5952E0;
        padding: 2px 5px;
        border-radius: 4px;
        text-transform: capitalize;
        transition: background 0.15s ease;

        &:hover {
            background: rgba(89, 82, 224, 0.1);
        }
    }

    .dp-header-year-wrap {
        position: relative;
        display: inline-flex;
        align-items: center;
    }

    .dp-header-year-trigger {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        margin-left: 4px;
        border: transparent;
        cursor: pointer;
        font: 14px Borna, "Segoe UI", sans-serif !important;
        color: #0B0B14;
        padding: 4px 20px 4px 8px;
        border-radius: 8px;
        line-height: 1;
        transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
        background-color: transparent;
    }

    .dp-header-year-trigger:hover {
        background: rgba(89, 82, 224, 0.08);
        border-color: rgba(89, 82, 224, 0.45);
    }

    .dp-header-year-trigger:focus-visible {
        outline: none;
        border-color: #5952E0;
        box-shadow: 0 0 0 2px rgba(89, 82, 224, 0.18);
    }

    .dp-header-year-caret {
        position: absolute;
        right: 8px;
        color: #5952E0;
        font-size: 8px;
        pointer-events: none;
        line-height: 1;
        font-weight: 600;
    }

    .dp-year-menu {
        position: absolute;
        top: calc(100% + 6px);
        right: 0;
        width: 108px;
        max-height: 240px;
        overflow-y: auto;
        padding: 6px;
        border: 1px solid #DFDFDF;
        border-radius: 10px;
        background: #ffffff;
        box-shadow: 0 8px 24px rgba(0, 58, 120, 0.18);
        z-index: 10000;
    }

    .dp-year-option {
        width: 100%;
        border: none;
        background: transparent;
        border-radius: 8px;
        padding: 8px 10px;
        text-align: left;
        cursor: pointer;
        color: #0B0B14;
        font: 14px Borna, "Segoe UI", sans-serif !important;
        transition: background 0.12s ease, color 0.12s ease;
    }

    .dp-year-option:hover {
        background: rgba(89, 82, 224, 0.08);
    }

    .dp-year-option:focus-visible {
        outline: none;
    }

    .dp-year-option--selected {
        color: #5952E0;
        font-weight: 600;
    }

    /* Keep datepicker popup above field labels */
    .react-datepicker-popper,
    .react-datepicker__portal {
        z-index: 9999 !important;
    }

    /* Flex row holding the month + year buttons in the day-view header */
    .dp-header-label-group {
        display: flex;
        align-items: center;
        gap: 2px;
    }

    /* Outer container for the notched-border label pattern */
    .dp-field-container {
        position: relative;
        width: 100%;
        margin-bottom: 0.5rem;
    }

    /* Label that sits on the top border — MUI outlined style */
    .dp-field-label {
        position: absolute;
        top: 0;
        left: 10px;
        z-index: 1;
        padding: 0 4px;
        background: #ffffff;
        font: 400 11px ${fontFamily}, "Segoe UI", sans-serif;
        color: #6f6a8f;
        pointer-events: none;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        /* Vertically centre the text on the border line */
        transform: translateY(-50%);
    }

    .dp-field-label--required::after {
        content: " *";
        color: #C20A38;
    }

    .dp-field-container:focus-within .dp-field-label:not(.dp-field-label--error) {
        color: #5952E0;
    }

    .dp-field-label--error {
        color: #C20A38;
    }

    /* Validation error message below the field */
    .dp-error-text {
        display: block;
        margin-top: 4px;
        font: 400 12px ${fontFamily}, "Segoe UI", sans-serif;
        color: #C20A38;
    }

    /* Day cells — base color */
    .react-datepicker__day,
    .react-datepicker__day-name {
        color: #0B0B14;
    }

    /* Day hover */
    .react-datepicker__day:hover {
        background: rgba(89, 82, 224, 0.08);
        border-radius: 4px;
    }

    /* Selected day — matches range-start/end style */
    .react-datepicker__day--selected,
    .react-datepicker__day--selected:hover {
        background-color: #5952E0 !important;
        color: #ffffff !important;
        border-radius: 4px !important;
    }

    /* Keyboard-focused day — remove default highlight so navigating months
       doesn't carry a "ghost selection" on the same day number.
       Preserve styling when the day is selected, today, or part of a range. */
    .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--today):not(.react-datepicker__day--in-range):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
    .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--today):not(.react-datepicker__day--in-range):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover {
        background-color: transparent;
        color: #0B0B14;
        border-radius: 4px;
    }

    /* Today indicator */
    .react-datepicker__day--today:not(.react-datepicker__day--selected) {
        background-color: #5952E0;
        color: #ffffff;
        border-radius: 4px;
    }

     /* Holiday highlighting */
    .react-datepicker__day.holiday:not(.react-datepicker__day--selected):not(.react-datepicker__day--today) {
        background: #FFCCD9;
        color: #C20A38;
        border-radius: 4px;
    }

    /* Year picker cells */
    .react-datepicker__year-wrapper {
        max-width: 220px;
        gap: 4px;
    }

    .react-datepicker__year-text {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 48px;
        height: 30px;
        border-radius: 4px;
        color: var(--heeros-blue-600-brand, #003A78);
        font: 13px ${fontFamily}, "Segoe UI", sans-serif;
    }

    .react-datepicker__year-text:hover {
        background: rgba(89, 82, 224, 0.08);
    }

    .react-datepicker__year-text--selected,
    .react-datepicker__year-text--selected:hover {
        background-color: #5952E0 !important;
        color: #ffffff !important;
    }

    .react-datepicker__year-text--keyboard-selected {
        background-color: rgba(89, 82, 224, 0.18);
        color: #5952E0;
    }
`;
